import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { OpEnum } from '../../../../shared/enums/op.enum';
var BondingComponent = /** @class */ (function () {
    function BondingComponent(copyService, abreCuentasService, headerService, parametersService, formBuilder, navigationService, productLoaderService, bitacoraService, firmlyApprovedService) {
        this.copyService = copyService;
        this.abreCuentasService = abreCuentasService;
        this.headerService = headerService;
        this.parametersService = parametersService;
        this.formBuilder = formBuilder;
        this.navigationService = navigationService;
        this.productLoaderService = productLoaderService;
        this.bitacoraService = bitacoraService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.checkboxTerms = {
            id: '',
            label: '',
            checked: false,
            value: '',
        };
        this.showMor = false;
        this.noShare = false;
        this.statusValidation = false;
        this.arrowIconDown = 'seta_baixo';
        this.arrowIconUp = 'seta_cima';
        this.products = [];
        this.cards = [{
                CARD: 'MASTERCARD',
            }];
    }
    BondingComponent.prototype.ngOnInit = function () {
        this.headerService.show(true, true, true);
        this.documentInfo = this.abreCuentasService.getDocumentInfo();
        this.products = this.abreCuentasService.getProductsSelects();
        console.log(this.products);
        this.terms = {
            text: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].description,
            title: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].code,
            terms_id: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].id,
        };
        // data quemada
        this.documentInfo.firstname = 'Ana';
        // fin data quemada
        this.checkboxTerms = {
            id: '1',
            label: this.copyService.copies.detail_account_bonding_terms,
            checked: false,
            value: '1',
        };
    };
    BondingComponent.prototype.showMore = function () {
        if (this.showMor) {
            this.showMor = false;
            return this.arrowIconUp;
        }
        else {
            this.showMor = true;
            return this.arrowIconDown;
        }
    };
    BondingComponent.prototype.showIcon = function () {
        if (this.showMor) {
            return this.arrowIconUp;
        }
        else {
            return this.arrowIconDown;
        }
    };
    BondingComponent.prototype.checkboxChange = function (event) {
        this.checkboxTerms.checked = event.checked;
        this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
        if (this.checkboxTerms.checked) {
            this.statusValidation = true;
        }
        else {
            this.statusValidation = false;
        }
    };
    BondingComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
                    this.registerBitacoraVinculations();
                }
                this.navigationService.navigateToGeneralInformation('130');
                return [2 /*return*/];
            });
        });
    };
    BondingComponent.prototype.toggleModal = function () {
        this.showModal = !this.showModal;
    };
    BondingComponent.prototype.registerBitacoraVinculations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var productVincul, productClient, dataBitacora, mergeProducts_1, bitacoraEvent;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        productVincul = this.abreCuentasService.productsSelectVicul;
                        productClient = this.abreCuentasService.getClientProduct();
                        if (!productVincul) return [3 /*break*/, 2];
                        dataBitacora = this.copyService.copies.products_vinculation;
                        mergeProducts_1 = '';
                        productVincul.forEach(function (element) {
                            mergeProducts_1 += element;
                        });
                        bitacoraEvent = dataBitacora[mergeProducts_1];
                        return [4 /*yield*/, this.bitacoraService.saveDataInBitacora(bitacoraEvent)];
                    case 1:
                        _a.sent();
                        this.abreCuentasService.productsSelectVicul.pop();
                        if (!productClient) {
                            this.bitacoraService.saveDataInBitacora(dataBitacora['savingsAccount']);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return BondingComponent;
}());
export { BondingComponent };
